// extracted by mini-css-extract-plugin
export default {"book-list":"BookList_book-list__+K907","pagination-buttons-container":"BookList_pagination-buttons-container__VSntP"};